import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';

export const DispNIngreso = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}DispNIngreso`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const DispRegulares = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}DispRegulares`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const DispEstAll = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}DispEstAll`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const EnviarNotif = (est, asunto, contenido, aplica, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            asunto: asunto,
            contenido: contenido,
            aplica: aplica
        }

        Post(`${Url}EnviarNotif`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    })
}


// WEBPACK FOOTER //
// ./src/funciones/EnviosFunction.jsx